import React, {useState} from "react";
import BaseModalV2 from "../../../components/Modals/BaseModalV2";
import { SquareCheckbox } from "../../../components/Inputs/SquareCheckbox/SquareCheckbox";
import './BulkDeleteUsersModal.css';
import Spinner from "../../../components/UISpinner/UISpinner";

function BulkDeleteUsersModal({
	size = "sm", 
	visible = true, 
	toggle = () => { },
	userAccountIds = [], 
	handleSubmit = () => { },
}) {
	const [disableSubmit, setDisableSubmit] = useState(true);
	const [disableCancel, setDisableCancel] = useState(false);
	const [isChecked, setIsChecked] = useState(false);
	const [isLoading, setIsLoading] = useState(false);

	function handleCheckboxChange(event) {
		setIsChecked(event.target.checked);
		setDisableSubmit(!event.target.checked);
	}

	async function onSubmit(e) {
		try {
			setDisableSubmit(true);
			setDisableCancel(true);
			setIsLoading(true);

			await handleSubmit();

			setIsChecked(false);
		}
		catch (error) {
			setDisableSubmit(false);
			setDisableCancel(false);

			throw error;
		}
		finally {
			setIsLoading(false);
		}
	}

	function handleToggle(){
		handleCheckboxChange({ target: { checked: false } })
		toggle();
	}

	return (
		<BaseModalV2
			className="confirm-remove-modal"
			size={size}
			visible={visible}
			toggle={handleToggle}
			headerContent={<div className="w-100 text-center">Confirm User Removal</div>}
			disableSubmit={disableSubmit}
			disableCancel={disableCancel}
			onSubmit={() => onSubmit()}
			onCancel={() => handleToggle()}
			submitText="Remove"
		>
			{!isLoading && <>
				<p className="text-center">Are you sure you want to remove user(s)?</p>
				<div className="user-delete-selection-container text-center mx-auto">
					<table className="user-remove-table table-striped">
						<tbody>
							{userAccountIds?.map((item) => (
								<tr key={item.accountId}>
									<td className="user-name">{item.name}</td>
									<td className="user-email">{item.email ?? 'NA'}</td>
								</tr>
							))}
						</tbody>
					</table>
				</div>

				<div className="d-flex align-items-center gap-7 bulk-delete-chk-container">
					<SquareCheckbox
						value={isChecked}
						valueChangeHandler={handleCheckboxChange}
						size="small"
						isDisabled={false}
						label="Yes, I want to remove user(s) from my organization."
						checkboxClassName="pt-3"
					/>

				</div>
				<div className="bottom-border"></div>
				<div>
					<p className="delete-warning-txt text-center small">
						*This action will remove user(s) access to your managed organizations and/or locations.
						You can reassign users by inviting them again from the User Management page.
					</p>
				</div>
			</>}
			{isLoading && <Spinner text="Removing users..." />}
		</BaseModalV2>
	);
}

export default BulkDeleteUsersModal;
